<template>
  <div>
    <el-dialog
      title="新增仓库"
      width="750px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="content_box33">
        <InputOne
          class="base_select_sty65"
          v-model="Warehouse.FullName"
          @changeVal="inputVal"
          name="仓库名称"
          field="FullName"
          reg="empty"
          :error="serror"
        />
        <InputOne
          class="base_select_sty65 margin_l_1_box"
          v-model="Warehouse.BaseCode"
          @changeVal="inputVal"
          name="仓库编号"
          field="BaseCode"
          reg="empty"
          :error="BaseCodeerror"
        />
        <!-- <div @dblclick="clickSearch" class="inputicon base_select_sty65 base_select">
          <span class="inputMust_text">所属分类</span>
          <el-input v-model="Warehouse.ParentNos" :disabled="true"></el-input>
          <i class="el-icon-search icons" @click="clickSearch"></i>
        </div>-->
        <InputOne
          class="base_select_sty65 isdisable"
          v-model="Warehouse.ParentNos"
          @changeVal="inputVal"
          :isMust="false"
          :isdisable="true"
          :icon2="true"
          @dblclick="clickSearch"
          @clickSearch="clickSearch"
          name="所属分类"
          field="ParentNos"
        />
        <InputOne
          class="base_select_sty65 margin_l_1_box"
          v-model="Warehouse.PyNo"
          @changeVal="inputVal"
          :isMust="false"
          :isdisable="true"
          name="助记码"
          field="PyNo"
        />
        <InputOne
          class="base_select_sty12"
          v-model="Warehouse.Memo"
          @changeVal="inputVal"
          name="备注"
          :isMust="false"
          field="Memo"
        />
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addsaveClick('fromdatas')">保存新增</el-button>
          <el-button type="primary" @click="saveClick('fromdatas')">保存返回</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog title="仓库分类" :visible.sync="dialogVisibleck" width="330px">
      <div class="member">
        <div class="member_box">
          <el-tree
            :data="datack"
            :props="defaultPropsck"
            accordion
            icon-class="iconfont icon-file-close "
            @node-click="handleNodeClickck"
            node-key="id"
            :default-expanded-keys="[0]"
          ></el-tree>
        </div>
      </div>
      <div class="member2">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibleck = false">取消</el-button>
          <el-button type="primary" @click="footerck">确定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vPinyin from "@/utils/PyConversion.js"; // 自动生成拼音助记码
// import local from "../../../utils/local"; //本地缓存存取
import tool from "@/utils/tool.js"; //本地缓存存取
// import session from "../../../utils/session"; //本地缓存存取
// import InputOne from "../../base/InputOne/InputOne";
// import treehistory from ".././treedata/treedata";

export default {
  components: {
    // InputOne,
    // treehistory
  },
  data() {
    return {
      dialogVisibleck: false,
      datasck: { id: "", label: "" },
      datack: [],
      defaultPropsck: {
        children: "children",
        label: "label"
      },
      visible: this.show,
      BaseCodeerror: "",
      serror: "",
      Warehouse: {
        ParentNos: "全部仓库",
        KtypeId: 0, //所属分类
        BaseCode: "", //仓库编号
        FullName: "", //仓库全名
        ParentNo: "", //父级ID
        Name: "", //仓库简名
        PyNo: "", //拼音码
        Memo: "", //备注
        nnn: "" //暂时无用
      }
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    BaseCodes() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        ParentNo: 0,
        table: "Stock"
      };
      this.request
        .post("/index/common/get_basecode", { jparams: JSON.stringify(params) })
        .then(res => {
          let { status, BaseCode } = res;
          if (status == 0) {
            this.Warehouse.BaseCode = BaseCode;
          }
        });
    },
    handleNodeClickck(data) {
      this.datasck = data;
    },
    footerck() {
      this.Warehouse.ParentNos = this.datasck.label;
      this.Warehouse.KtypeId = this.datasck.id;
      this.dialogVisibleck = false;
    },
    clickSearch() {
      this.clicknedeck();
      this.dialogVisibleck = true;
    },
    clicknedeck() {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid //用户凭证
      };

      this.request
        .post("/index/Stock/getlist", { jparams: JSON.stringify(params) })
        .then(res => {
          let { status, data, tree } = res;
          let aa = [];
          for (let i = 0; i < tree.length; i++) {
            const element = tree[i];
            aa.push(element);
          }
          this.datack = aa;
        });
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
    },
    // 当前input值改变
    inputVal(data, fieldData) {
      this.Warehouse[fieldData] = data;
      this.Warehouse.PyNo = vPinyin.makePy(this.Warehouse.FullName);
    },
    // 保存返回
    saveClick(Warehouse) {
      if (this.Warehouse.FullName == "") {
        this.serror = "该值不能为空";
      }
      if (this.Warehouse.BaseCode == "") {
        this.BaseCodeerror = "该值不能为空";
      }
      if (this.Warehouse.FullName != "" && this.Warehouse.BaseCode != "") {
        let params = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"), //用户凭证
          ParentNo: this.Warehouse.KtypeId, //该仓库的父级仓库Id
          BaseCode: this.Warehouse.BaseCode, //用户编号
          FullName: this.Warehouse.FullName, //仓库全名
          Name: this.Warehouse.Name, //仓库简名
          Memo: this.Warehouse.Memo, //备注
          PyNo: this.Warehouse.PyNo,
          IsDir: 0
        };
        this.request
          .post("/index/Stock/add", { jparams: JSON.stringify(params) })
          .then(res => {
            let { status, description } = res;
            if (status == 0) {
              this.$message({
                showClose: true,
                message: description,
                type: "success"
              });
              this.Initialization();
              this.closeDialog();
            } else {
              this.$message({
                showClose: true,
                message: description,
                type: "success"
              });
            }
          })
          .catch(err => {
            this.$message.error("添加错误");
            // console.log("失败"); // 失败的数据
          });

        this.BaseCodeerror = "";
        this.serror = "";
      }
    },
    Initialization() {
      this.Warehouse = {
        ParentNos: this.Warehouse.ParentNos,
        KtypeId: this.Warehouse.KtypeId, //所属分类
        BaseCode: "", //仓库编号
        FullName: "", //仓库全名
        ParentNo: "", //父级ID
        Name: "", //仓库简名
        PyNo: "", //拼音码
        Memo: "", //备注
        nnn: "" //暂时无用
      };
    },
    // 保存新增
    addsaveClick() {
      if (this.Warehouse.FullName == "") {
        this.serror = "该值不能为空";
      }
      if (this.Warehouse.BaseCode == "") {
        this.BaseCodeerror = "该值不能为空";
      }
      if (this.Warehouse.FullName != "" && this.Warehouse.BaseCode != "") {
        let params = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"), //用户凭证
          ParentNo: this.Warehouse.KtypeId, //该仓库的父级仓库Id
          BaseCode: this.Warehouse.BaseCode, //用户编号
          FullName: this.Warehouse.FullName, //仓库全名
          Name: this.Warehouse.Name, //仓库简名
          Memo: this.Warehouse.Memo, //备注
          PyNo: this.Warehouse.PyNo,
          IsDir: 0
        };
        this.request
          .post("/index/Stock/add", { jparams: JSON.stringify(params) })
          .then(res => {
            let { status, description } = res;
            if (status == 0) {
              this.$message({
                showClose: true,
                message: description,
                type: "success"
              });
              this.Initialization();
              this.BaseCodes();
            } else {
              this.$message({
                showClose: true,
                message: description,
                type: "success"
              });
            }
          });
        this.BaseCodeerror = "";
        this.serror = "";
      }
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    visible: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.BaseCodes();
        }
      }
    }
  }
};
</script>

<style lang="less">
.content_box33 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .base_select_sty12 {
    width: 99.5%;
    margin-top: 10px;
  }
  .base_select_sty65 {
    width: 331px;
    margin-top: 15px;
    line-height: 27px;
    padding: 0;
  }

  .margin_l_1_box {
    margin-left: 41px;
  }
  .isdisable {
    cursor: pointer !important;
    .el-input__inner {
      cursor: pointer !important;
    }
  }
  .dialog-footer {
    width: 100%;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 20px 0 10px;
  }
}
.member {
  width: 100%;
  height: 300px;
  border: 1px solid #ccc;
  overflow: hidden;
  .member_box {
    width: 106%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-tree-node__expand-icon {
    font-size: 20px;
  }
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg) !important;
    transform: rotate(0deg) !important;
  }
  .el-tree-node__expand-icon.expanded::before {
    content: "\e62e";
    font-size: 22px;
  }
}
.member2 {
  margin-top: 7px;
  display: flex;
  justify-content: flex-end;
  .el-dialog__footer {
    padding: 0px 18px 6px;
  }
  .dialog-footer {
    // margin-left: 156px;
    .el-button {
      padding: 8px 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/AddStorehouse/AddStorehouse.vue